import React, {useState} from 'react';
import './GrantPremiumPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {API_BASE} from '../../../utils/apiConfig';

const PAGE_ID = 'GrantPremiumPage';

/**
 * Начисление премиума пользователю (только суперадмины, гейт на сервере).
 * Премиум действует с момента начисления; повторное начисление при активном
 * премиуме продлевает его — дни прибавляются к остатку.
 */
function GrantPremiumPage({targetUserId, targetUserName, onBack}) {
  usePageAnalytics('GrantPremiumPage');
  const [days, setDays] = useState('');
  const [granting, setGranting] = useState(false);
  const [grantedUntil, setGrantedUntil] = useState(null);

  const handleGrant = async () => {
    const parsedDays = parseInt(days, 10);
    if (!parsedDays || parsedDays <= 0 || granting) return;

    setGranting(true);
    setGrantedUntil(null);
    try {
      const response = await fetch(`${API_BASE}/admin/grant-premium`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({targetUserId, days: parsedDays}),
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.error || 'Failed to grant premium');
      }

      setGrantedUntil(data.premiumExpiresAt || null);
      setDays('');
    } catch (e) {
      console.error('Grant premium error', e);
      alert(e.message || 'Не удалось начислить премиум');
    } finally {
      setGranting(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleGrant();
    }
  };

  return (
    <>
      <h1 className="lobby-page-title grant-premium-page-title">
        Начислить премиум
        {targetUserName && <span className="grant-premium-page-subtitle">{targetUserName}</span>}
      </h1>

      <div className="grant-premium-form">
        <label className="grant-premium-label" htmlFor="grant-premium-days">
          Количество дней премиума
        </label>
        <input
          id="grant-premium-days"
          className="grant-premium-input"
          type="number"
          min="1"
          value={days}
          onChange={(e) => setDays(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Например, 30"
          disabled={granting}
        />

        <PageButton
          className="grant-premium-submit"
          onClick={handleGrant}
          pageId={PAGE_ID}
          buttonId="grant"
          disabled={granting || !days || parseInt(days, 10) <= 0}
        >
          {granting ? 'Начисление...' : 'Начислить'}
        </PageButton>

        {grantedUntil && (
          <div className="grant-premium-success">
            Премиум действует до {new Date(grantedUntil).toLocaleString('ru-RU')}
          </div>
        )}
      </div>

      <div className="main-menu-buttons grant-premium-page-buttons">
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default GrantPremiumPage;
